/* global Symbol */
import * as syncActionCreators from '../sync';
import * as contactStore from '../sync/contacts';
import { push } from 'react-router-redux';
import { APPLICANT_STATUS } from '../../helpers/staticData';

import Promise from 'bluebird';
import _ from 'lodash';

// Prelim Application
export function submitApplicant(body) {
  return simpleIsoFetch => dispatch =>
    simpleIsoFetch.post({
      route: '/api/applicants',
      body
    })
    .then(({body: responseBody}) =>
      dispatch(syncActionCreators.updatePrelimForm({
        isQualified: responseBody.status === 'success'
      })))
    .catch(err => {
      // if(!err || !~[400].indexOf(err.status)) {
      //   console.error(err);
      // }

      // reach here, existing applicant with 'Uninterested' or 'Unresponsive' tried to apply again
      if (err.body.errors && err.body.errors[0].errorCode === 104) {
        dispatch(syncActionCreators.updatePrelimForm({
          isDupQualifiedAndUnresponsive: true,
          assignedSpecialist: err.body.errors[0].qs,
        }));
      }

      // reach here, that means try to create account with same email and applicant is In Waiting
      if (err.body.errors && err.body.errors[0].errorCode === 103) {
        dispatch(syncActionCreators.updatePrelimForm({
          isDupAndInWaiting: true,
          assignedSpecialist: err.body.errors[0].qs,
        }));
      }


      if (err.body && err.body.errors && err.body.errors[0].errorCode === 102) {
        dispatch(syncActionCreators.updatePrelimForm({
          isDupAndUnqualified: true,
        }));
      }

      // reach here, that means try to create account with same email.
      if (err.body && err.body.errors && err.body.errors[0].errorCode === 100) {
        dispatch(syncActionCreators.updatePrelimForm({
          alreadyExists: true,
          assignedSpecialist: err.body.errors[0].qs
        }));
      }


    });
}

export function authorizeApplication(applicant) {
  return simpleIsoFetch => dispatch =>
    simpleIsoFetch.put({
      route: `/api/applicants/${applicant.profile.id}/authorize`
    })
    .then(() => {
        dispatch(syncActionCreators.updateApplicant({profile: {applicantStatus: APPLICANT_STATUS.PENDING_ASSESSMENTS, dateAuthorized: (new Date()).toDateString()}}));
      }
    )
    .catch(err => console.error(err));
}

// Applicant

// loads only Contact Information Section for on Applicant Login
export function loadRestofApplicantProfileInfo(id) {
   if (_.isNil(id)) { return Promise.resolve(); }

  return simpleIsoFetch => dispatch =>
    Promise.all([
      simpleIsoFetch.get(`/api/applicants/${id}/workexperiences`),
      simpleIsoFetch.get(`/api/applicants/${id}/employmentgaps`),
      simpleIsoFetch.get(`/api/applicants/${id}/skills`),
      simpleIsoFetch.get(`/api/applicants/${id}/associations`),
      simpleIsoFetch.get(`/api/applicants/${id}/designations`),
      simpleIsoFetch.get(`/api/applicants/${id}/education`),
      simpleIsoFetch.get(`/api/applicants/${id}/licenses`),
      simpleIsoFetch.get(`/api/applicants/${id}/documents`),
      simpleIsoFetch.get(`/api/applicants/${id}/references`),
      simpleIsoFetch.get(`/api/applicants/${id}/references/interviews`),
      simpleIsoFetch.get(`/api/applicants/${id}/behavioral`),
      simpleIsoFetch.get(`/api/applicants/${id}/workobjectives`),
      simpleIsoFetch.get(`/api/applicants/${id}/ratings`),
      simpleIsoFetch.get(`/api/applicants/${id}/assessments`),
      simpleIsoFetch.get(`/api/v2/applicants/${id}/technology`),
    ])
    .then(([
      {body: {data: {items: [workExperiences]}}},
      {body: {data: {items: [employmentGaps]}}},
      {body: {data: {items: skills}}},
      {body: {data: {items: associations}}},
      {body: {data: {items: designations}}},
      {body: {data: {items: [education]}}},
      {body: {data: {items: [licenses]}}},
      {body: {data: {items: [documents]}}},
      {body: {data: {items: [references]}}},
      {body: {data: {items: interviews}}},
      {body: {data: {items: answers}}},
      {body: {data: {items: workObjectives}}},
      {body: {data: {items: ratings}}},
      {body: {data: {items: assessments}}},
      {body: {data: technologySurvey}}
    ]) => {
      return dispatch(syncActionCreators.updateApplicant({
        workExperiences,
        employmentGaps,
        skills: _.reduce(skills, (obj, skill) => {
                            if (!obj[skill.categoryId]) {
                              obj[skill.categoryId] = {};
                            }
                            obj[skill.categoryId][skill.name] = skill;
                            return obj;
                          }, {}),
        associations: _.keyBy(associations, 'name'),
        designations: _.keyBy(designations, 'name'),
        education,
        licenses,
        documents,
        references,
        interviews: _.keyBy(interviews, 'clientId'),
        behavioralAnswers: _.keyBy(answers, 'questionId'),
        workObjectives: _.keyBy(workObjectives, 'questionId'),
        ratings: _.keyBy(ratings, 'ratingId'),
        assessments: _.keyBy(assessments, 'testId'),
        technologySurvey
      }));
    })
    .catch((err) => {
      return Promise.reject(err, 'Unable to load rest of applicant profile info');
    });
}

export function loadApplicantProfileInfo(id) {
 if (_.isNil(id)) { return Promise.resolve(); }

  return simpleIsoFetch => dispatch =>
    _.isNil(id) ? Promise.resolve() :
    Promise.all([
      simpleIsoFetch.get(`/api/applicants/${id}`),
      simpleIsoFetch.get(`/api/applicants/${id}/user`)
    ])
    .then(([
      {body: {data: {items: [profile]}}},
      {body: {data: {items: [applicantUser]}}}
    ]) => {
      dispatch(syncActionCreators.updateApplicant({
        profile,
        applicantUser,
      }));
    })
    .catch((err) => {
      return Promise.reject(err, 'Unable to load Applicant Profile Info');
    });
}

export function getProfileById(id) {
  if (_.isNil(id)) { return Promise.resolve(); }
  return simpleIsoFetch => dispatch =>
    _.isNil(id) ? Promise.resolve() :
    Promise.all([
      simpleIsoFetch.get(`/api/applicants/${id}`),
      simpleIsoFetch.get(`/api/applicants/${id}/user`),
      simpleIsoFetch.get(`/api/applicants/${id}/workexperiences`),
      simpleIsoFetch.get(`/api/applicants/${id}/employmentgaps`),
      simpleIsoFetch.get(`/api/applicants/${id}/skills`),
      simpleIsoFetch.get(`/api/applicants/${id}/associations`),
      simpleIsoFetch.get(`/api/applicants/${id}/designations`),
      simpleIsoFetch.get(`/api/applicants/${id}/education`),
      simpleIsoFetch.get(`/api/applicants/${id}/licenses`),
      simpleIsoFetch.get(`/api/applicants/${id}/documents`),
      simpleIsoFetch.get(`/api/applicants/${id}/references`),
      simpleIsoFetch.get(`/api/applicants/${id}/references/interviews`),
      simpleIsoFetch.get(`/api/applicants/${id}/behavioral`),
      simpleIsoFetch.get(`/api/applicants/${id}/workobjectives`),
      simpleIsoFetch.get(`/api/applicants/${id}/ratings`),
      simpleIsoFetch.get(`/api/applicants/${id}/assessments`),
      simpleIsoFetch.get(`/api/applicants/${id}/technologysurveys`)
    ])
    .then(
      (
        [
          {body: {data: {items: [profile]}}},
          {body: {data: {items: [applicantUser]}}},
          {body: {data: {items: [workExperiences]}}},
          {body: {data: {items: [employmentGaps]}}},
          {body: {data: {items: skills}}},
          {body: {data: {items: associations}}},
          {body: {data: {items: designations}}},
          {body: {data: {items: [education]}}},
          {body: {data: {items: [licenses]}}},
          {body: {data: {items: [documents]}}},
          {body: {data: {items: [references]}}},
          {body: {data: {items: interviews}}},
          {body: {data: {items: answers}}},
          {body: {data: {items: workObjectives}}},
          {body: {data: {items: ratings}}},
          {body: {data: {items: assessments}}},
          {body: {data: {items: [technologySurvey]}}},
        ]
      ) =>
      dispatch(syncActionCreators.updateApplicant({
        profile,
        applicantUser,
        workExperiences,
        employmentGaps,
        skills: _.reduce(skills, (obj, skill) => {
                            if (!obj[skill.categoryId]) {
                              obj[skill.categoryId] = {};
                            }
                            obj[skill.categoryId][skill.name] = skill;
                            return obj;
                          }, {}),
        associations: _.keyBy(associations, 'name'),
        designations: _.keyBy(designations, 'name'),
        education,
        licenses,
        documents,
        references,
        interviews: _.keyBy(interviews, 'clientId'),
        behavioralAnswers: _.keyBy(answers, 'questionId'),
        workObjectives: _.keyBy(workObjectives, 'questionId'),
        ratings: _.keyBy(ratings, 'ratingId'),
        assessments: _.keyBy(assessments, 'testId'),
        technologySurvey
      })))
    .catch(err => console.error(err));
}

export function persistApplicantUpdate(updateObj) {
  return simpleIsoFetch => dispatch => {
    simpleIsoFetch.put(`/api/applicants/${updateObj.profile.id}`, {
      body: updateObj
    })
    .then(() => true)
    .catch(err => console.error(err));
  };
}

export function persistListUpdate(route, property, updateObj) {
  return simpleIsoFetch => () =>
    Promise.all(
      _.map(updateObj[property], ({isNew, ...experience}, clientId) =>
        isNew
        &&
        simpleIsoFetch.post(`/api/applicants/${updateObj.profile.id}/${route}/${clientId}`, {
          body: experience
        })
        ||
        updateObj[property][clientId] === Symbol.for('__delete')
        &&
        simpleIsoFetch.del(`/api/applicants/${updateObj.profile.id}/${route}/${clientId}`)
        ||
        simpleIsoFetch.put(`/api/applicants/${updateObj.profile.id}/${route}/${clientId}`, {
          body: experience
        })
      ).concat(
        // allow for profile properties to be added in addition to list ones
        Object.keys(updateObj.profile).length > 1
        &&
        simpleIsoFetch.put(`/api/applicants/${updateObj.profile.id}`, {
          body: _.pick(updateObj, ['profile', 'user'])
        })
        ||
        []
      )
    )
    .then()
    .catch(err => console.error(err));
}


export function updateApplicantList(route, property, applicantId, clientId, updateObj) {
  return simpleIsoFetch => dispatch => {
    simpleIsoFetch.put(`/api/applicants/${applicantId}/${route}/${clientId}`, {
      body: updateObj
    })
    .then()
    .catch(err => console.error(err));
  };
}

export function persistSkills(updateObj) {
  const skills = _.pickBy(updateObj.skills, (i) => !_.isNil(i));
  const updates = _.compact(_.map(skills, cat => {
    const list = _.filter(cat, (s) => s && !s.deleted);
    return list.length ? list : undefined;
  }));
  const deletions = _.flatten(_.map(skills, cat => _.filter(cat, (s) => s.deleted === Symbol.for('_deleted_'))));

  return simpleIsoFetch => () =>
    Promise.all(
      _.map(updates, update =>
        simpleIsoFetch.post(`/api/applicants/${updateObj.profile.id}/skills/category/${update[0].categoryId}`, {
          body: update
        })
      ),
      _.map(deletions, skill =>
        simpleIsoFetch.del(`/api/applicants/${updateObj.profile.id}/skills/category/${skill.categoryId}`, {
          query: {name: skill.name}
        })
      ).concat(
        _.get(updateObj, 'profile.viewState', null)
        &&
        simpleIsoFetch.put(`/api/applicants/${updateObj.profile.id}`, {
          body: _.pick(updateObj, ['profile', 'user'])
        })
        ||
        []
      )
    )
    .then()
    .catch(err => console.error(err));
}

export function persistBackground(updateObj, resource) {
  const updates = _.map(_.filter(updateObj[resource], (item) => item && !item.deleted), i => i.name);
  const deletions = _.map(_.filter(updateObj[resource], (item) => item && item.deleted === Symbol.for('_deleted_')), i => i.name);

  return simpleIsoFetch => () =>
    Promise.all([
      updates.length ?
        simpleIsoFetch.post(`/api/applicants/${updateObj.profile.id}/${resource}`, {
          body: updates
        })
        : Promise.resolve()
      ,
      deletions.length ?
        simpleIsoFetch.del(`/api/applicants/${updateObj.profile.id}/${resource}`, {
          body: deletions
        })
        : Promise.resolve()
    ].concat(
      _.get(updateObj, 'profile.viewState', null)
      &&
      simpleIsoFetch.put(`/api/applicants/${updateObj.profile.id}`, {
        body: _.pick(updateObj, ['profile', 'user'])
      })
      ||
      []
    ))
    .then()
    .catch(err => console.error(err));
}

export function deleteWorkExperience(profileId, clientId) {
  return simpleIsoFetch => dispatch => {
    dispatch(syncActionCreators.deleteWorkExperience(clientId));
    return simpleIsoFetch.del(`/api/applicants/${profileId}/workExperiences/${clientId}`)
      .then()
      .catch(err => console.error(err));
  };
}

// Admin
export function search(terms, filters) {
  return simpleIsoFetch => (dispatch, getState) =>
    Promise.props( // pull names off static 'statusGroup' values and 'maps' through them to make promise object properties
      _(getState().user.statusGroups)
        .keyBy()
        .mapValues((value, key) =>
          simpleIsoFetch.get({
            route: '/api/applicants',
            query: {
              group: key,
              terms,
              ...filters,
              mode: 'list',
            }
          }))
        .value()
    )
    .then(PromiseRes =>
      dispatch(syncActionCreators.updateApplicantsList(_.mapValues(PromiseRes, statusGroup => statusGroup.body.data))))
    .catch(err => console.error(err));
}

export function goToPage(terms, filters, group, skip, sortBy) {
  return simpleIsoFetch => (dispatch) =>
    simpleIsoFetch.get({
      route: '/api/applicants',
      query: {
        group,
        terms,
        skip,
        ...filters,
        ...sortBy,
        mode: 'list',
      }
    })
    .then(({body: {data}}) =>
      dispatch(syncActionCreators.updateApplicantsPage(group, data)))
    .catch(err => console.error(err));
}

// Admin
export function retrieve(id) {
  return simpleIsoFetch => (dispatch) =>
    simpleIsoFetch.get({
      route: '/api/applicants',
      query: {
        id,
        mode: 'detail'
      }
    })
    .then(({body: {data: {items: [applicant]}}}) => dispatch(syncActionCreators.updateCurrentApplicantAdmin(applicant)))
    .catch(err => console.error(err));
}

// Admin
export function searchContacts(terms, filters = {}, skip, limit) {
  return simpleIsoFetch => (dispatch, getState) =>
    simpleIsoFetch.get({
      route: '/api/contacts',
      query: {
        terms,
        ...filters,
        skip,
        limit
      }
    })
    .then(PromiseRes => {
      dispatch(syncActionCreators.updateContactsPage(PromiseRes.body.data));
    })
    .catch(err => console.error(err));
}

// Admin
export function searchCompanies(terms, filters) {
  return simpleIsoFetch => (dispatch, getState) =>
    simpleIsoFetch.get({
      route: '/api/companies',
      query: {
        terms,
        ...filters,
      }
    })
    .then(PromiseRes => {
      dispatch(syncActionCreators.updateCompaniesList(PromiseRes.body.data));
    })
    .catch(err => console.error(err));
}

export function updateApplicantAdmin(updatedApplicant, group, arrayIndex, callback) {
  return simpleIsoFetch => (dispatch, getState) => {
    dispatch(syncActionCreators.updateApplicantAdmin(updatedApplicant, group, arrayIndex));


    // handle conversion of dropdowns to ids
    const updatedApplicantServer = _.cloneDeep(updatedApplicant);
      _.forEach(updatedApplicantServer, applicantProp => {
        _.merge(applicantProp, _.mapValues(applicantProp, updatingProp =>
            updatingProp && updatingProp.hasOwnProperty('name') ? updatingProp.id : updatingProp));
      });

    // handle applicantData json update for server
    if(updatedApplicantServer.profile.accordionData) {
      _.merge(updatedApplicantServer.profile.accordionData, getState().admin.applicants[group][arrayIndex].profile.accordionData || {});
    }

    return simpleIsoFetch.put({
      route: `/api/applicants/${updatedApplicant.profile.id}`,
      body: updatedApplicantServer
    })
    .then(data => {
      if (callback) {
        return callback(null, data);
      }
      else {
        return data;
      }
    })
    .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
        console.error(err);
      }
      if (callback) callback(err);
    });
  };
}

export function updateApplicantStatus(applicant, status, group, arrayIndex) {
  return simpleIsoFetch => (dispatch, getState) => {

    const statusGroups = getState().staticData.statusGroups;
    const newGroup = _.find(statusGroups, g => ~g.statuses.indexOf(status.id));
    applicant.profile.applicantStatus = status;
    applicant.profile.statusGroup = newGroup.name;
    dispatch(syncActionCreators.updateApplicant(applicant));
    dispatch(syncActionCreators.updateApplicantAdmin(applicant, group, arrayIndex, newGroup.name));

    simpleIsoFetch.put({
      route: `/api/applicants/${applicant.profile.id}/status/${status.id}`
    })
    .then()
    .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
    });
  };
}

export function deleteApplicant(applicantId, group) {
  return simpleIsoFetch => (dispatch) => {
    simpleIsoFetch.del({
      route: `/api/applicants/${applicantId}`
    })
    .then(() => dispatch(syncActionCreators.deleteApplicantAdmin(applicantId, group)))
    .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
    });
  };
}

export function submitEvent(eventRoute, body, eventExtra) {
  return simpleIsoFetch => (dispatch, getState) => {
    const {
      user: {
        id,
        name
      }
    } = getState();
    if (body.applicantId) {
      if(eventExtra && eventExtra.type == 'edit') {
          simpleIsoFetch.put({
            route: `/api/applicants/${body.applicantId}/${eventRoute}/`+eventExtra.param,
            body: _.omit(body, ['taskTypeName'])
        })
        .then((resp => {
            dispatch(syncActionCreators.updateEventList(_.merge({
              eventRoute,
              dateCreated: Date(),
              createdBy: {
                userId: id,
                name
              }
            }, body)));
            }), (err => {
               console.log(err);
            })
          );
      }else{
          simpleIsoFetch.post({
            route: `/api/applicants/${body.applicantId}/${eventRoute}`,
            body: _.omit(body, ['taskTypeName'])
        })
        .then(
          (resp => {
            body.id =  resp.body.data.items[0].id
            dispatch(syncActionCreators.updateEventList(_.merge({
              eventRoute,
              dateCreated: Date(),
              createdBy: {
                userId: id,
                name
              }
            }, body)));
          }),(err => {
            console.log(err);
          })
        );
      }
    }
  };
}

export function getApplicantBehavioralAnswers(applicant) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.get({
      route: `/api/applicants/${applicant.profile.id}/behavioral`
    })
    .then(
      ({body: {data: {items: answers}}}) => {
        const behavioralAnswers = _.keyBy(answers, 'questionId');
        dispatch(syncActionCreators.updateApplicantBehavioralAnswers({
          behavioralAnswers
        }));
    })
    .catch(err => {
      console.error(err)
    });
  };
}

export function updateApplicantBehavioralAnswers(applicant, behavioralAnswers, group, arrayIndex) {
  return simpleIsoFetch => dispatch => {

    dispatch(syncActionCreators.updateApplicantBehavioralAnswers({
      behavioralAnswers
    }));

    const body = [];
    _.each(behavioralAnswers, function(value, key) {
      body.push({questionId: key, answer: value.answer});
    });

    simpleIsoFetch.post({
      route: `/api/applicants/${applicant.profile.id}/behavioral`,
      body
    })
    .then()
    .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
    });
  };
}

export function getApplicantWorkObjectives(applicant) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.get({
      route: `/api/applicants/${applicant.profile.id}/workobjectives`
    })
    .then(
      ({body: {data: {items: answers}}}) => {
        const workObjectives = _.keyBy(answers, 'questionId');
        dispatch(syncActionCreators.updateApplicantWorkObjectives({
          workObjectives
        }));
    })
    .catch(err => {
      console.error(err)
    });
  };
}

export function updateApplicantWorkObjectives(applicant, workObjectives, group, arrayIndex) {
  return simpleIsoFetch => dispatch => {

    dispatch(syncActionCreators.updateApplicantWorkObjectives({
      workObjectives
    }));

    let body = [];
    _.each(workObjectives, function(value, key) {
      body.push({questionId: key, answer: value.answer});
    });

    simpleIsoFetch.post({
      route: `/api/applicants/${applicant.profile.id}/workobjectives`,
      body
    })
    .then()
    .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
    });
  };
}

export function updateApplicantInterviewRatings(applicant, ratings, group, arrayIndex) {
  return simpleIsoFetch => dispatch => {

    dispatch(syncActionCreators.updateApplicantInterviewRatings({
      ratings
    }));

    let body = [];
    _.each(ratings, function(value, key) {
      body.push({ratingId: key, rating: value.rating});
    });

    simpleIsoFetch.post({
      route: `/api/applicants/${applicant.profile.id}/ratings`,
      body
    })
    .then()
    .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
    });
  };
}

// DEPRECATED
export function updateApplicantAssessments(applicant, assessments) {
  return simpleIsoFetch => dispatch => {
    dispatch(syncActionCreators.updateApplicantAssessments({
      assessments
    }));

    let body = [];
    _.each(assessments, function(value, key) {
      body.push({testId: key, ...value});
    });

    simpleIsoFetch.post({
      route: `/api/applicants/${applicant.profile.id}/assessments`,
      body
    })
    .then()
    .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
    });

  };
}

export function persistReferencesInterviews(applicant, body) {
  const route = `/api/applicants/${applicant.profile.id}/references/interviews`;
  return simpleIsoFetch => dispatch => {
    const req = (body.isNew) ?
                simpleIsoFetch.post({route, body}) :
                simpleIsoFetch.put({route: `${route}/${body.clientId}`, body});
    req.then(() => { dispatch(syncActionCreators.updateApplicantReferencesInterviews({...body, isNew: false, isDirty: false})); })
    .catch(err => {
      console.error(err);
    });
  };
}

export function retrievePlacementSpecialists() {
  return simpleIsoFetch => dispatch => {
    simpleIsoFetch.get({
      route: '/api/admin/employees',
      query: {
        roleName: 'Placement Specialist'
      }
    })
    .then(({body: {data: {items: specialists}}}) => dispatch(syncActionCreators.updatePlacementSpecialists(specialists)))
    .catch(err => {
      console.error(err);
    });
  };
}

export function createProspect(body, callback) {
  return simpleIsoFetch => dispatch => {
    simpleIsoFetch.post({
      route: `/api/contacts`,
    body
  })
  .then((resp) => {
    callback.success(resp.body.data.items);
  }, (err) => {
      callback.error(err)
  })
    .catch(err => {

        if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
    });
  };
}

export function updateProspect(body, callback) {
  return simpleIsoFetch => dispatch => {
    simpleIsoFetch.put({
      route: `/api/contacts/${body.contactId}`,
    body
  })
  .then((resp) => {
    callback.success(resp.body.data.items);
  }, (err) => {
      callback.error(err)
  })
    .catch(err => {

        if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
    });
  };
}

export function checkAndCreateContact(body, callback) {
  return simpleIsoFetch => dispatch => {
    simpleIsoFetch.post({
      route: `/api/contacts/check`,
    body
  })
  .then((resp) => {
    callback.success(resp.body.data.items);
  }, (err) => {
      callback.error(err);
  })
    .catch(err => {
        if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
    });
  };
}

export function submitContactEvent(contactEventRoute, body, eventExtra) {
  return simpleIsoFetch => (dispatch, getState) => {
    const {
      user: {
        id,
        name
      }
    } = getState();
    if (body.contactId) {
      if(eventExtra && eventExtra.type == 'edit') {
          simpleIsoFetch.put({
            route: `/api/contacts/${body.contactId}/${contactEventRoute}/`+eventExtra.param,
            body: _.omit(body, ['taskTypeName'])
        })
        .then((resp => {
            dispatch(syncActionCreators.updateContactEventList(_.merge({
              contactEventRoute,
              dateCreated: Date(),
              createdBy: {
                userId: id,
                name
              }
            }, body)));
            }), (err => {
               console.log(err);
            })
          );
      }else{
          simpleIsoFetch.post({
            route: `/api/contacts/${body.contactId}/${contactEventRoute}`,
            body: _.omit(body, ['taskTypeName'])
        })
        .then(
          (resp => {
            body.id =  resp.body.data.items[0].id
            dispatch(syncActionCreators.updateContactEventList(_.merge({
              contactEventRoute,
              dateCreated: Date(),
              createdBy: {
                userId: id,
                name
              }
            }, body)));
          }),(err => {
            console.log(err);
          })
        );
      }
    }
  }
}

export function updatePassword(body, callback) {
  return simpleIsoFetch => dispatch => {
        simpleIsoFetch.put({
          route: `/api/users/${body.id}`,
        body
      })
        .then((resp) => {
            callback.success(resp);
        }, (err) => {
          callback.error(err)
        })
        .catch(err => {
          if (!err || !~[400].indexOf(err.status)) {
          console.log(err);
        }
    });
  };
}

// Companies
export function getCompanyById(id, callback) {
  return simpleIsoFetch => (dispatch) => {
    return simpleIsoFetch.get({
        route: `/api/companies/${id}`
    })
    .then((res) => {

      if(callback && callback.success) {
        return callback.success(res.body.data);
      }

      return res.body.data;

      })
    .catch(err => {

      if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }

      if(callback && callback.error) {
        return callback.error(err);
      }

      return err;

      });
  };
}


// Alerts
export function getAlerts(callback) {
  return simpleIsoFetch => dispatch => {
    simpleIsoFetch.get({
        route: `/api/alerts`
      })
      .then(
        ({body:{data:items}}) => {
          callback.success(items);
        }, (err) => {
          callback.error(err);
    })
  .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
      console.log(err);
    }
  });
  };
}

export function readAlert(alertId, callback) {
  return simpleIsoFetch => dispatch => {
    simpleIsoFetch.get({
        route: `/api/alerts/${alertId}`
      })
      .then(
        ({body:{data:items}}) => {
          callback.success(items);
        }, (err) => {
          callback.error(err);
    })
  .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
      console.log(err);
    }
  });
  };
}

export function deleteAlert(alertId, callback) {
  return simpleIsoFetch => dispatch => {
    simpleIsoFetch.del({
        route: `/api/alerts/${alertId}`
      })
      .then(
        ({body:{data:items}}) => {
          callback.success(items);
        }, (err) => {
          callback.error(err);
    })
  .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
      console.log(err);
    }
  });
  };
}

export function getApplicantAssessmentTests(id, cb) {
 if (_.isNil(id)) { return Promise.reject('Applicant ID is null'); }

  return simpleIsoFetch => () =>
    simpleIsoFetch.get(`/api/applicants/${id}/assessments/tests`)
      .then(({body: {data: {items}}}) =>
        (cb) ? cb(null, items) : items
      )
      .catch(err => (cb) ? cb(err) : Promise.reject(err));
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/index.js